<template>
    <div class="d-flex">
        <b-button variant="default" @click="$bvModal.show(modalId)"> View </b-button>
        <b-button variant="default" @click="markAs(params.data.is_read)" style="margin-left: 5px">
            <font-awesome-icon
                :icon="['fas', 'arrow-rotate-right']"
                v-if="params.data.is_read"
                title="Mark As Unread"
            />
            <font-awesome-icon :icon="['fas', 'check']" v-else title="Mark As Read" />
        </b-button>
        <notification-modal
            :subject="params.data.subject"
            :message="params.data.body"
            :modalId="modalId"
            :date="params.data.date"
            :notificationId="params.data.id.toString()"
            :href="params.data.href"
        ></notification-modal>
    </div>
</template>

<script>
    import Modal from '../generic/modal/modal.vue';
    import API from '../../api';
    import { NOTIFICATION_ENDPOINT } from '../../endpoints';
    import { mapMutations } from 'vuex';
    import { NOTIFICATION_DROPDOWN_MAX } from '../../constants';
    import NotificationModal from './notification-modal.vue';

    export default {
        components: {
            Modal,
            NotificationModal,
        },
        computed: {
            modalId() {
                return 'show-message-modal' + this.params.data.id;
            },
        },
        methods: {
            ...mapMutations('header', ['setNotificationList']),
            async markAs(is_read) {
                await API.patch(`${NOTIFICATION_ENDPOINT()}notifications_set_${is_read ? 'unread' : 'read'}/`, {
                    notification_id: this.params.data.id,
                });
                const notificationList = await API.get(`${NOTIFICATION_ENDPOINT()}notifications/`, {
                    params: {
                        offset: 0,
                        limit: NOTIFICATION_DROPDOWN_MAX,
                        sort: 'date',
                        desc: true,
                        is_read: false,
                    },
                });
                this.setNotificationList(notificationList.data);

                this.params.data.is_read = !this.params.data.is_read;
                this.params.api.refreshCells({
                    rowNodes: [this.params.node],
                    force: true,
                });
            },
        },
    };
</script>

<style scoped lang="scss">
    .iframe-content {
        border: none;
    }
</style>
<style>
    .communication-iframe-modal {
        min-height: 400px;
    }
</style>
